<template>
  <div id="room-infomation-tab">
    <div class="tab-header">
      <v-row>
        <v-col sm="6">
          <label class="tab-title">{{ $t("SELLING_PACKAGE_INFO") }}</label>
        </v-col>
        <v-col sm="6" class="text-right">
          <button class="btn btn-back mr-5" @click="back">{{ $t("BACK") }}</button>
          <button class="btn btn-save" @click="save">{{ $t("SAVE") }}</button>
        </v-col>
      </v-row>
    </div>
    <div class="tab-content" v-if="editedItem">
      <v-tabs v-model="tab" class="pl-0">
        <v-tab>{{ $t("VIETNAMESE") }}</v-tab>
        <v-tab>{{ $t("ENGLISH") }}</v-tab>
      </v-tabs>
      <v-row v-if="editedItem.i18ns.find(x => x.lang == lang)">
        <v-col sm="12">
          <label class="label-input">{{ $t("NAME_SELLING_PACKAGE") }} *</label>
          <input-text
            :model.sync="editedItem.i18ns.find(x => x.lang == lang).name"
            :error="tab == 0 ? errors.nameVi.error : errors.nameEn.error"
          />
        </v-col>
        <v-col sm="12">
          <label class="label-input">{{ $t("DESCRIPTION_INFO") }}</label>
          <!-- <vue-editor v-model="editedItem.i18ns.find(x => x.lang == lang).description"></vue-editor> -->
          <input-textarea
                    :rows="3"
                   :model.sync="editedItem.i18ns.find(x => x.lang == lang).description"
                  />
        </v-col>
      </v-row>
      <v-divider />
      <v-row>
        <v-col sm="6" class="pb-1">
          <label class="label-input">{{ $t("PACKEAGE_APPLY_FOR") }} *</label>
          <v-row>
            <v-col class="d-flex py-0">
              <div class="d-flex align-center pr-2" style="width: 52%">
                <select-text
                  class="pr-2"
                  style="flex: 1"
                  :items="select.adult"
                  :model.sync="editedItem.adultsIncluded"
                />
                <span style="color: #808080">{{ $t("ADULT") }}</span>
              </div>
              <div class="d-flex align-center pl-2" style="width: 48%">
                <select-text
                  class="pr-2"
                  style="flex: 1"
                  :items="select.child"
                  :model.sync="editedItem.childrenInclued"
                />
                <span style="color: #808080">{{ $t("CHILDREN") }}</span>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col sm="6" class="pb-1">
          <v-row>
            <v-col md="12" class="py-0">
              <label class="label-input">{{ $t("MEALS_INCLUDE") }}</label>
              <multiSelect :options="select.meals" :model.sync="editedItem.lstMealId" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="6" class="py-0">
          <v-row>
            <v-col sm="6">
              <label class="label-input">{{ $t("MIN_NIGHT") }} *</label>
              <input-text
                :notSmallThan="0"
                :regex="REGEX_NUMBER"
                :model.sync="editedItem.minStay"
                :error.sync="errors.minStay.error"
              />
            </v-col>
            <v-col sm="6">
              <label class="label-input">{{ $t("MAX_NIGHT") }} *</label>
              <input-text
                :notSmallThan="0"
                :regex="REGEX_NUMBER"
                :model.sync="editedItem.maxStay"
                :error.sync="errors.maxStay.error"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col sm="6" class="py-0">
          <v-row>
            <v-col>
              <label class="label-input">{{ $t("EXTRA_BED_PRICE") }} ({{ currencyCode }})</label>
              <input-text
                :notSmallThan="0"
                :isMoney="true"
                :regex="REGEX_NUMBER"
                :model.sync="editedItem.extraBedPrice"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="6">
          <label class="label-input">{{ $t("EXTRA_ADULT_PRICE") }} ({{ currencyCode }})</label>
          <input-text
            :notSmallThan="0"
            :isMoney="true"
            :regex="REGEX_NUMBER"
            :model.sync="editedItem.exAdult"
          />
        </v-col>
        <v-col sm="6">
          <label class="label-input">{{ $t("EXTRA_CHILD_PRICE") }} ({{ currencyCode }})</label>
          <input-text
            :notSmallThan="0"
            :isMoney="true"
            :regex="REGEX_NUMBER"
            :model.sync="editedItem.exChild"
          />
        </v-col>
      </v-row>
      <label class="label-input mb-0 mt-2">{{ $t("TIME_STAY") }}</label>
      <v-radio-group row v-model="editedItem.sesType" class="mt-0 pl-2">
        <v-radio color="indigo darken-3" :label="$t('ALWAYS')" :value="0"></v-radio>
        <v-radio color="indigo darken-3" :label="$t('IN_PERIOD')" :value="1"></v-radio>
      </v-radio-group>
      <v-row>
        <v-col sm="3" class="pb-0 pt-2">
          <label class="label-input mb-0">{{ $t("FROM_DATE") }}</label>
          <date-picker
            :model.sync="editedItem.start"
            :disabled="!editedItem.sesType"
            :error.sync="errors.start.error"
          />
        </v-col>
        <v-col sm="3" class="pb-0 pt-2">
          <label class="label-input mb-0">{{ $t("TO_DATE") }}</label>
          <date-picker
            :model.sync="editedItem.end"
            :disabled="!editedItem.sesType"
            :min="editedItem.start"
            :error.sync="errors.end.error"
          />
        </v-col>
      </v-row>
      <div class="v-row">
        <label class="label-input mt-3 mb-0">{{ $t("DAYS_NOT_APPLY") }}</label>
        <v-row class="day-not-applied">
          <v-col sm="3" class="py-0" v-for="(date, i) in notApplyDates" :key="i">
            <v-flex class="d-flex">
              <date-picker :model.sync="date.date" />
              <v-icon color="indigo" @click="removeDate(i)">delete</v-icon>
            </v-flex>
          </v-col>
        </v-row>
        <div>
          <v-icon color="#173d8f" @click="addnotApplyDates">add</v-icon>
          <label class="has-action" @click="addnotApplyDates">{{ $t("ADD_DAYS_NOT_APPLY") }}</label>
        </div>
      </div>
      <v-checkbox
        color="indigo darken-3"
        :label="$t('STATE_ACTIVE_OR_DEACTIVE')"
        v-model="editedItem.active"
      />
      <v-divider />

      <label class="label-input">{{ $t("TYPE_ROOM_APPLIED") }} *</label>
      <v-row v-if="listOfRooms">
        <v-col
          md="6"
          class="child-no-margin py-0"
          v-if="room.i18ns && room.i18ns.find(x => x.lang == sysLang)"
          v-for="room in listOfRooms"
          :key="room.id"
        >
          <v-checkbox
            color="indigo darken-3"
            :label="room.i18ns.find(x => x.lang == sysLang).name"
            :value="room.id"
            :error="errors.roomsApply.error"
            v-model="roomTyleApplied"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import DatePicker from "@/components/Utils/DatePicker.vue";
import MultiSelect from "@/components/Utils/MultiSelect.vue";
import { VueEditor } from "vue2-editor";
//import Multiselect from "vue-multiselect";
import Input from "@/components/Utils/Input.vue";
import Select from "@/components/Utils/Select.vue";
import { salePackageService } from "@/_services/SaleRoom/sale-package.service.js";
import { service } from "@/_services/RoomInfomation/list-of-rooms.service.js";

import {
  _validateFormI18n,
  _alert,
  _formatCurrency,
  _resetErrorState
} from "@/_helpers/function.js";
import { REGEX_NUMBER } from "@/_helpers/constant.js";
import {
  MAX_CHILD_QUANTITY,
  MAX_ADULTS_QUANTITY,
  MEALS,
  SPD_ERROR
} from "@/_helpers/config.js";
import Textarea from "@/components/Utils/Textarea.vue";
export default {
  components: {
    //Multiselect,
    "date-picker": DatePicker,
    "input-text": Input,
    "select-text": Select,
    multiSelect: MultiSelect,
    VueEditor,
    "input-textarea": Textarea
  },
  created() {
    this.initialize();
  },
  data() {
    return {
      editedItem: null,
      currencyCode: JSON.parse(localStorage.getItem("currentUser")).hotel
        .currency
        ? JSON.parse(localStorage.getItem("currentUser")).hotel.currency.code ||
          "VND"
        : "VND",
      tab: null,
      sysLang: this.$i18n.locale,
      lang: "vi",
      select: {
        child: Array.from(Array(MAX_CHILD_QUANTITY).keys()),
        adult: Array.from(Array(MAX_ADULTS_QUANTITY).keys()).map(x => ++x),
        meals: MEALS.map(x => {
          return {
            id: x.id,
            value: x.id,
            text: x[this.$i18n.locale]
          };
        })
      },
      notApplyDates: [],
      listOfRooms: [],
      roomTyleApplied: [],
      errors: SPD_ERROR,
      listMeal: [],
    };
  },
  computed: {
    REGEX_NUMBER() {
      return REGEX_NUMBER;
    }
  },
  watch: {
    listOfRooms(value) {
      let element = document.querySelector(".btn-save");
      if (value.length > 0) {
        element.disabled = false;
      } else {
        element.disabled = true;
      }
    },
    tab(value) {
      this.lang = value ? "en" : "vi";
    },
    lang(value) {
      this.editorData = this.editedItem.i18ns.find(
        x => x.lang == value
      ).description;
    },
    roomTyleApplied(value) {
      this.editedItem.rooms = [...value];
    },
    editedItem: {
      handler(value) {
        if (value.rooms.length) {
          this.errors.roomsApply.error = false;
        }
        if (value.start > value.end) {
          this.editedItem.end = "";
        }
      },
      deep: true
    }
  },
  mounted() {
    document
      .querySelector(".v-tab.v-tab--active")
      .classList.remove("v-tab--active");
    document
      .querySelector(".v-tab[tabIndex='0']")
      .classList.add("v-tab--active");
  },
  methods: {
    async initialize() {
      _resetErrorState(this.errors);
      let id = parseFloat(this.$route.params.id);
      if (id) {
        await salePackageService.getDetail(id).then(res => {
          this.editedItem = res.data;
          const arrayID = [];
          res.data.lstMealId.forEach(e => {
            arrayID.push(e.id);
          });
          this.editedItem.lstMealId = [...arrayID];
          this.editedItem.notApplyDates.forEach(x => {
            this.notApplyDates.push({ date: x });
          });
        });
        // await salePackageService.get().then(res => {
        //   this.editedItem = Object.assign({}, res.data.find(x => x.id == id));
        //   this.editedItem.notApplyDates.forEach(x => {
        //     this.notApplyDates.push({ date: x });
        //   });
        // });
      } else {
        this.editedItem = {
          adultsIncluded: 1,
          childrenInclued: 0,
          exAdult: null,
          aexType: 1,
          mealId: null,
          exChild: null,
          cexType: 0,
          start: "",
          end: "",
          sesType: 0,
          minStay: 0,
          maxStay: 30,
          active: true,
          extraBedPrice: null,
          notApplyDates: [],
          rooms: [],
          // roomType: [],
          lstMealId: [],
          i18ns: [
            { description: "", lang: "vi", name: "" },
            { description: "", lang: "en", name: "" }
          ],
        };
      }
      Object.keys(this.errors).forEach(x => {
        this.errors[x].error = false;
      });
      this.editorData = this.editedItem.i18ns.find(
        x => x.lang == this.lang
      ).description;
      const idRoomType = [];
      this.editedItem.rooms.forEach(e => {
        idRoomType.push(e.id);
      })
      this.roomTyleApplied = [...idRoomType];
      // console.log(this.select.meals);
      // Set default data
      this.editedItem.minStay = this.editedItem.minStay || 1;
      this.editedItem.sesType = this.editedItem.sesType || 0;
      await service.getAllRooms().then(res => {
        if (res.responseCode == 0) {
          this.listOfRooms = res.data.map(x => {
            return {
              id: x.roomId,
              i18ns: x.i18ns,
              maxCapacity: x.maxAdults + x.maxChildern + x.numberOfExtraBeds
            };
          });
          this.roomTyleApplied = this.roomTyleApplied.filter(x =>
            this.listOfRooms.map(x => x.id).includes(x)
          );
        }
        // let promises = res.data.map(async x => {
        //   let numberOfExtraBeds;
        //   await service.getRoomDetail(x.roomId).then(res => {
        //     if (res.responseCode == 0) {
        //       numberOfExtraBeds = res.data.numberOfExtraBeds;
        //     }
        //   });
        //   return {
        //     id: x.roomId,
        //     i18ns: x.i18ns,
        //     maxCapacity: x.maxAdults + x.maxChildern + numberOfExtraBeds
        //   };
        // });
        // Promise.all(promises).then(res => {
        //   this.listOfRooms = res;
        //   this.roomTyleApplied = this.roomTyleApplied.filter(x =>
        //     res.map(x => x.id).includes(x)
        //   );
        // });
      });
    },
    async save() {
      let element = document.querySelector(".btn-save");
      element.disabled = true;
      this.editedItem.notApplyDates = this.notApplyDates.map(x => x.date);
      // this.editedItem.lstMealId = this.select.meals;
      // console.log(this.select.meals);
      let tempData = {
        nameVi: this.editedItem.i18ns.find(x => x.lang == "vi").name,
        nameEn: this.editedItem.i18ns.find(x => x.lang == "en").name,
        minStay: this.editedItem.minStay,
        maxStay: this.editedItem.maxStay,
      };
      let { isValid, error } = _validateFormI18n(tempData, this.errors);
      this.errors = error;
      if (this.editedItem.maxStay < this.editedItem.minStay) {
        this.$store.commit("alert/display", {
          message: this.$t("MAX_STAY_NOT_SMALL_THAN_MIN_STAY"),
          error: true,
          success: false
        });
        this.errors.maxStay.error = true;
        element.disabled = false;
        isValid = false;
      }
      if (!this.editedItem.rooms.length) {
        this.$store.commit("alert/display", {
          message: this.$t("MISSING_FIELD"),
          error: true,
          success: false
        });
        this.errors.roomsApply.error = true;
        element.disabled = false;
        isValid = false;
      }
      if (this.editedItem.sesType) {
        if (!this.editedItem.start) {
          this.errors.start.error = true;
          isValid = false;
        }
        if (!this.editedItem.end) {
          this.errors.end.error = true;
          isValid = false;
        }
      } else {
        this.errors.start.error = false;
        this.errors.end.error = false;
      }
      if (this.errors.start.error || this.errors.end.error) {
        this.$store.commit("alert/display", {
          message: this.$t("MISSING_FIELD"),
          error: true,
          success: false
        });
        element.disabled = false;
        isValid = false;
      }
      if (this.errors.nameVi.error) {
        element.disabled = false;
        this.tab = 0;
        return false;
      }
      if (this.errors.nameEn.error) {
        element.disabled = false;
        this.tab = 1;
        return false;
      }
      if (!isValid) {
        element.disabled = false;
        return false;
      }
      let maxCustomerRoomApply = 0;
      if (this.roomTyleApplied.length)
        maxCustomerRoomApply = Math.min(
          ...this.editedItem.rooms.map(
            x => this.listOfRooms.find(y => y.id == x).maxCapacity
          )
        );
      if (
        maxCustomerRoomApply &&
        this.editedItem.rooms.length &&
        this.editedItem.adultsIncluded + this.editedItem.childrenInclued >
          maxCustomerRoomApply
      ) {
        this.$store.commit("alert/display", {
          message:
            this.$t("CUSTOMER_PACKAGE_NOT_BIGGER_THAN_ROOM") +
            " (" +
            maxCustomerRoomApply +
            ")",
          error: true,
          success: false
        });
        element.disabled = false;
        return false;
      }
      if (this.editedItem.id) {
        await salePackageService.update(this.editedItem).then(res => {
          _alert(res, this.$t(res.data));
          if (res.responseCode != 0) {
            element.disabled = false;
          }
        });
      } else {
        await salePackageService.create(this.editedItem).then(res => {
          if (res.responseCode == 0) {
            _alert(res, this.$t("CREATE_SUCCESS"), false);
          }
          let vm = this;
          setTimeout(function() {
            vm.$router.push({ name: "listOfSalePackages" });
          }, 1000);
          if (res.responseCode != 0) {
            _alert(res, this.$t(res.data));
            element.disabled = false;
          }
        });
      }
    },
    back() {
      this.$router.back();
    },
    addnotApplyDates() {
      this.notApplyDates.push({
        date: null
      });
    },
    removeDate(index) {
      this.notApplyDates.splice(index, 1);
    },
    _formatCurrency: _formatCurrency
  }
};
</script>